import type { LocaleSignals, PageContext } from "./types";
import { safe } from "./utils/safe";

export function collectContext(): PageContext {
  return {
    domain: safe(() => location.hostname, ""),
    pageUrl: safe(() => location.href, ""),
    referrer: safe(() => document.referrer, ""),
    utm: safe(() => {
      const sp = new URLSearchParams(location.search);
      const out: Record<string, string> = {};
      sp.forEach((value, key) => {
        if (key.toLowerCase().startsWith("utm_")) out[key] = value;
      });
      return out;
    }, {}),
    fbclid: safe(() => new URLSearchParams(location.search).get("fbclid"), null),
  };
}

export function collectLocale(): LocaleSignals {
  return {
    systemTime: safe(() => new Date().toISOString(), ""),
    timezone: safe(() => Intl.DateTimeFormat().resolvedOptions().timeZone || null, null),
    timezoneOffset: safe(() => new Date().getTimezoneOffset(), 0),
    locale: safe(() => Intl.DateTimeFormat().resolvedOptions().locale || navigator.language || null, null),
  };
}
